import { supabase } from "../supabase/client";

export type IncomeProjectionDaily = {
  id: string;
  user_id: string;
  log_date: string;
  avg_daily_income: number;
  created_at: string;
};

const TABLE = "income_projection_daily";

async function getUserId(): Promise<string | null> {
  const { data, error } = await supabase.auth.getUser();
  if (error) {
    console.error("[incomeProjectionDB] Failed to get user", error);
    return null;
  }
  return data.user?.id ?? null;
}

export async function upsertDailyAverage(
  logDate: string,
  avgDailyIncome: number
): Promise<void> {
  const userId = await getUserId();
  if (!userId) return;

  const payload = {
    user_id: userId,
    log_date: logDate,
    avg_daily_income: avgDailyIncome,
  };

  const { error } = await supabase
    .from(TABLE)
    .upsert(payload, { onConflict: "user_id,log_date" });

  if (error) {
    console.error("[incomeProjectionDB] Upsert failed", {
      error,
      logDate,
      avgDailyIncome,
    });
  } else {
    console.debug("[incomeProjectionDB] Upserted daily average", payload);
  }
}

export async function fetchDailyAverages(
  startDate: string,
  endDate: string
): Promise<IncomeProjectionDaily[]> {
  const userId = await getUserId();
  if (!userId) return [];

  const { data, error } = await supabase
    .from(TABLE)
    .select("id,user_id,log_date,avg_daily_income,created_at")
    .eq("user_id", userId)
    .gte("log_date", startDate)
    .lte("log_date", endDate)
    .order("log_date", { ascending: true });

  if (error) {
    console.error("[incomeProjectionDB] Fetch failed", {
      error,
      startDate,
      endDate,
    });
    return [];
  }

  return data || [];
}
